export const ACCEPTED_FILE_TYPES =
  'video/mp4,video/mkv,video/x-m4v,video/*,image/jpg,image/jpeg,image/png,image/gif,image/bmp,image/svg+xml,image/webp';
